$(function () {
	window.onYouTubeIframeAPIReady = function () {
		$('.js-video').each(function () {
			const $video = $(this);
			//const $container = $video.closest('.video');
			//const $btn = $container.find('.js-video-play');
			let videoId = $video.data('youtube-id');
			let player = new YT.Player(this, {
				//playerVars: {
				//	'playsinline': 1,
				//	'controls': 0,
				//	'list': 0,
				//	'loop': 0,
				//	'enablejsapi': 1,
				//},
				videoId: videoId,
				//events: {
				//	onReady: function () {
				//		player.mute();
				//	},
				//	//onStateChange: function (event) {
				//	//	if (event.data == 0) {
				//	//		$container.removeClass('is-playing');
				//	//	}
				//	//}
				//}
			});

			////Start youtube video on button click
			//$btn.click(function (event) {
			//	event.preventDefault();
			//	$container.addClass('is-playing');
			//	player.playVideo();
			//});
		});
	}
})